import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tw-min-h-[calc(100vh-60px)] tw-bg-gradient-to-br tw-from-slate-50 tw-via-white tw-to-indigo-50 tw-py-6" }
const _hoisted_2 = { class: "tw-mx-auto tw-w-full tw-max-w-7xl tw-px-4 sm:tw-px-6 lg:tw-px-8" }
const _hoisted_3 = {
  key: 0,
  class: "tw-flex tw-justify-center tw-py-16"
}
const _hoisted_4 = {
  key: 1,
  class: "tw-w-full"
}
const _hoisted_5 = { class: "tw-text-base sm:tw-text-lg tw-font-semibold tw-text-slate-900 tw-mr-4 tw-inline-block" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "tw-text-sm tw-text-slate-600 tw-inline-block" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "tw--m-5" }
const _hoisted_11 = { class: "tw-mb-4 tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between" }
const _hoisted_12 = { class: "tw-w-full sm:tw-w-[520px]" }
const _hoisted_13 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50" }
const _hoisted_14 = {
  key: 0,
  class: "tw-flex tw-items-center tw-justify-center tw-py-10"
}
const _hoisted_15 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-px-6 tw-py-12"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "tw-mt-6 tw-flex tw-justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_ContainerModal = _resolveComponent("ContainerModal")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_AddNotesModal = _resolveComponent("AddNotesModal")!
  const _component_ContainerTable = _resolveComponent("ContainerTable")!
  const _component_PaginationBar = _resolveComponent("PaginationBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.mainLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "tw-h-10 tw-w-10 tw-animate-spin tw-rounded-full tw-border-4 tw-border-slate-200 tw-border-t-slate-600" }, null, -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Modal, {
              isOpen: _ctx.isContainerModalOpen,
              "onUpdate:isOpen": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isContainerModalOpen) = $event)),
              modalId: "archived-container-modal",
              maxWidth: "7xl"
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.currentContainerFromList)
                    ? (_openBlock(), _createBlock(_component_CopyButton, {
                        key: 0,
                        value: String(_ctx.currentContainerFromList.containerId),
                        mode: "wrap-content",
                        title: "Copy container ID",
                        "aria-label": "Copy container ID to clipboard"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.currentContainerFromList.containerId), 1)
                        ]),
                        _: 1
                      }, 8, ["value"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, "Container"))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.currentContainerFromList?.billOfLading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _cache[4] || (_cache[4] = _createTextVNode(" BL# ", -1)),
                        _createVNode(_component_CopyButton, {
                          value: _ctx.currentContainerFromList.billOfLading.billOfLadingNumber,
                          mode: "wrap-content",
                          title: "Copy B/L number",
                          "aria-label": "Copy B/L number to clipboard"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.currentContainerFromList.billOfLading.billOfLadingNumber), 1)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.currentContainerFromList?.bookingNumber)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _cache[5] || (_cache[5] = _createTextVNode(" Booking # ", -1)),
                        _createVNode(_component_CopyButton, {
                          value: _ctx.currentContainerFromList.bookingNumber,
                          mode: "wrap-content",
                          title: "Copy Booking number",
                          "aria-label": "Copy Booking number to clipboard"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.currentContainerFromList.bookingNumber), 1)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ContainerModal, {
                    containerId: _ctx.currentContainerId,
                    containerFromList: _ctx.currentContainerFromList,
                    enableVessel: false,
                    onClose: _ctx.closeContainerModal,
                    onUnarchiveContainer: _ctx.unarchiveContainer
                  }, null, 8, ["containerId", "containerFromList", "onClose", "onUnarchiveContainer"])
                ])
              ]),
              _: 1
            }, 8, ["isOpen"]),
            _createVNode(_component_AddNotesModal, {
              open: _ctx.containerNotesModalOpen,
              title: "Container notes",
              subtitle: _ctx.containerNotesSelected ? String(_ctx.containerNotesSelected.containerId) : undefined,
              container: _ctx.containerNotesSelected,
              onClose: _ctx.closeContainerNotes,
              onAddedNote: _ctx.onContainerNotesAdded,
              onArchivedNotesUpdated: _ctx.onContainerArchivedNotesUpdated
            }, null, 8, ["open", "subtitle", "container", "onClose", "onAddedNote", "onArchivedNotesUpdated"]),
            _createElementVNode("div", _hoisted_11, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "tw-text-left" }, [
                _createElementVNode("h3", { class: "tw-text-xl tw-font-semibold tw-text-slate-900" }, "Archived Containers"),
                _createElementVNode("div", { class: "tw-mt-1 tw-text-sm tw-text-slate-600" }, "Search, review, and unarchive containers.")
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  class: "tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/70 tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-slate-900/10",
                  type: "search",
                  placeholder: "Search by Container Number, B/L Number, or Customer Name",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchInput) = $event)),
                  onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.searchInput]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.tableLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("div", { class: "tw-h-8 tw-w-8 tw-animate-spin tw-rounded-full tw-border-4 tw-border-slate-200 tw-border-t-slate-600" }, null, -1)
                  ]))]))
                : (_ctx.archivedContainersEnumerated.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("div", { class: "tw-text-base tw-font-semibold tw-text-slate-900" }, "No archived containers", -1),
                      _createElementVNode("div", { class: "tw-max-w-md tw-text-center tw-text-sm tw-text-slate-600" }, " Try adjusting your search term, or check back later if you recently archived something. ", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_component_ContainerTable, {
                        onRefreshContainers: _ctx.refreshContainers,
                        onUnarchiveContainer: _ctx.unarchiveContainer,
                        containers: _ctx.archivedContainersEnumerated,
                        condensed: _ctx.user.enableCustomerInfo != true,
                        markedUpdatedContainers: _ctx.markedUpdatedContainers,
                        onSelectContainer: _ctx.selectArchivedContainer,
                        onOpenContainerNotes: _ctx.openContainerNotes,
                        sortBy: _ctx.sortBy,
                        onUpdateSortBy: _ctx.updateSortBy
                      }, null, 8, ["onRefreshContainers", "onUnarchiveContainer", "containers", "condensed", "markedUpdatedContainers", "onSelectContainer", "onOpenContainerNotes", "sortBy", "onUpdateSortBy"])
                    ]))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_PaginationBar, {
                page: _ctx.pageNum,
                totalPages: _ctx.pageCount || 1,
                disabled: _ctx.tableLoading,
                onPreviousPage: _ctx.prevPage,
                onNextPage: _ctx.nextPage,
                onGoToPage: _ctx.goToPage
              }, null, 8, ["page", "totalPages", "disabled", "onPreviousPage", "onNextPage", "onGoToPage"])
            ])
          ]))
    ])
  ]))
}